// Hardcoded temporary pause: hide all Amanita products and the bundle containing Amanita.
// Set to false and redeploy to restore them without changing their content.
export const AMANITA_PRODUCTS_PAUSED = true;

export const isProductTemporarilyUnavailable = (slug?: string | null): boolean =>
  AMANITA_PRODUCTS_PAUSED && /(?:^|\/)shop\/(?:amanita-[^/]+|tinctures-set-of-3)(?:\/|$)/i.test(slug || '');
